export const swiperSliderDefaultProps = {
    navigation: {
        nextEl: '.swiper-custom-arrow-right',
        prevEl: '.swiper-custom-arrow-left',
    },
    pagination: {
        clickable: true,
    },
}

